import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { fitCallUrl } from "@/lib/booking";
import { PhoneCallLink } from "@/components/site/PhoneCallLink";

type BookFitCallProps = {
  placement: string;
  buttonClassName: string;
  noteClassName: string;
  children?: ReactNode;
  className?: string;
};

export function BookFitCall({
  placement,
  buttonClassName,
  noteClassName,
  children = "Book a fit call",
  className = "",
}: BookFitCallProps) {
  return (
    <div className={`book-fit-call flex min-w-0 flex-col items-start ${className}`}>
      <a
        href={fitCallUrl(placement)}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonClassName}
        data-analytics-cta="Book a fit call"
        data-analytics-location={placement}
      >
        {children}
      </a>
      <Link
        to="/contact"
        className={noteClassName}
        data-analytics-cta="Or send a note instead"
        data-analytics-location={placement}
      >
        Or send a note instead
      </Link>
      <PhoneCallLink placement={placement} className={noteClassName} />
    </div>
  );
}
